import React from "react";
import styles from "css/mobile/mypage.module.css";

function ResDetailInfo({ index, value, marginTop }) {
  return (
    <div
      className={styles.detailInfo_container}
      style={{ marginTop: `${marginTop}px` }}
    >
      <div className={styles.info_index}>{index}</div>
      <div className={styles.info_value}>
        {typeof value === "string" ? (
          value !== "" ? (
            value
          ) : (
            "-"
          )
        ) : Array.isArray(value) ? (
          <div className={styles.info_list_container}>
            {value.length > 0
              ? value.map((el, index) => (
                  <div key={index} className={styles.info_list_content}>
                    <div className={styles.name}>{el.VALUE_1}</div> <p />
                    {el.VALUE_2 !== "" &&
                      el.VALUE_2 !== null &&
                      el.VALUE_2 !== undefined &&
                      el.VALUE_1 !== el.VALUE_2 && (
                        <div className={styles.email}>[{el.VALUE_2}]</div>
                      )}
                  </div>
                ))
              : "-"}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ResDetailInfo;
